import React, { useEffect } from "react";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import { NotificationApi } from "states/api/notification";
import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

export default function NoticeDetail() {
  const params = useParams();
  const id = params?.id;

  const { data, refetch } = useQuery(
    ["notice", "detail", id],
    () =>
      NotificationApi.getDetail({
        id,
      }),
    {
      staleTime: 300000,
    }
  );

  useEffect(() => {
    refetch();
  }, []);

  return (
    <div className="container introduce-page !mt-[50px]">
      <HeaderTop title="Thông báo" />
      <div className="no_content mt-[20px]">
        <div className="news-detail">
          <h2>{data?.title}</h2>
          {/* <div dangerouslySetInnerHTML={{ __html: data?.content }} /> */}
          <textarea readOnly value={data?.content} />
        </div>
      </div>
    </div>
  );
}
